function timeFormat(time) {
  const date = new Date(time * 1000);

  let hours = date.getHours();
  let period = "AM";

  if (hours - 12 > 0) {
    period = "PM";
  }

  if (hours % 12 < 10) {
    hours = `0${hours % 12}`;
  } else {
    hours = `${hours % 12}`;
  }

  let minutes = date.getMinutes();

  if (minutes < 10) {
    minutes = `0${minutes}`;
  }

  return `${hours}:${minutes} ${period}`;
}

export { timeFormat };
